import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { AllProductLines } from 'self-service-api/constants/ProductLines';
import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
import MobileProductLineSelectorButton from './MobileProductLineSelectorButton';
const FlexButtonContainer = styled(UIFlex).withConfig({
  displayName: "MobileProductLineSelectorButtonContainer__FlexButtonContainer",
  componentId: "bx1kp-0"
})(["width:94%;"]);
const ButtonContainer = styled.div.withConfig({
  displayName: "MobileProductLineSelectorButtonContainer__ButtonContainer",
  componentId: "bx1kp-1"
})(["min-width:100%;margin:0 auto;"]);
export const initialModalState = AllProductLines.reduce((accMap, productLine) => {
  accMap[productLine] = false;
  return accMap;
}, {});

const MobileProductLineSelectorButtonContainer = () => {
  const [modalOpenState, setModalState] = useState(initialModalState);

  const handleShowModal = productLine => {
    setModalState(state => Object.assign({}, state, {
      [productLine]: true
    }));
  };

  const handleHideModal = productLine => {
    setModalState(state => Object.assign({}, state, {
      [productLine]: false
    }));
  };

  const renderProductLineButtons = () => AllProductLines.map(productLine => /*#__PURE__*/_jsx(ButtonContainer, {
    children: /*#__PURE__*/_jsx(MobileProductLineSelectorButton, {
      productLine: productLine,
      handleShowModal: handleShowModal,
      handleHideModal: handleHideModal,
      active: modalOpenState[productLine]
    })
  }, productLine));

  return /*#__PURE__*/_jsx(FlexButtonContainer, {
    className: "m-top-5 text-center",
    direction: "column",
    align: "center",
    justify: "center",
    children: renderProductLineButtons()
  });
};

export default MobileProductLineSelectorButtonContainer;